<template>
  <div>
    <img src="/images/angela.jpg" alt="Angela Sielski" class=" float-none sm:float-left w-4/5 sm:w-2/3 md:w-1/3 mr-10 mb-6">

    <BaseHeading :level="5">About Angela</BaseHeading>

<p class="text-xl font-light mb-6">MotherHustler: Where motherhood meets real estate. Family comes first. Every decision is intentional. I serve my clients with patience, honesty, and deep respect- guiding them to clear, confident moves and decisions that truly support their life.  
</p>

<p class="text-xl font-light mb-6">Serving as a volunteer for many organizations in the Metuchen area, I have invested my personal time to contribute to the rich tapestry of community that exists in the Metuchen/Edison area. From the arts to our local library, pedestrian advocacy issues, historical society, family-building activities, LGBTQ+ ally, and issues of local government, I am committed to the overall strength and stability of the diverse community that I am proud to call home. As former executive director of the Metuchen Area Chamber of Commerce, I have intimate knowledge of our local economy. I also offer technical knowledge as I am certified by the State of New Jersey, Department of Community Affairs in "Land Use Law and Planning." I mentor other agents and proudly serve as a board member for the MidJersey Association of Realtors as well as on several local and state level committees to further improve our industry standards.</p> 

<p class="text-xl font-light mb-6">Proximity to public transportation, highways, the Middlesex Greenway project for biking and walking, many arts and music programs for all ages, and a great mix of mom-and-pop shops combined with nationally recognized chains means you'd have the best of all worlds right here in Central New Jersey.</p>

<p class="text-xl font-light mb-6">Buying, selling, or renting can be an intimidating process, let me help you with enthusiasm and positivity to get the job done!</p>

</div>
</template>

<script>

import BaseHeading from '@/components/BaseHeading.vue'

export default {
  name: 'AboutMe',
  components: {
    BaseHeading
  }
}
</script>
